export const UNSUBSCRIBE_REQUEST = 'unsubscribe/REQUEST';
export const UNSUBSCRIBE_SUCCESS = 'unsubscribe/SUCCESS';
export const UNSUBSCRIBE_FAILURE = 'unsubscribe/FAILURE';
